export const TIER_DOT = {
  BG_COLOR: Styles.color.grey.eight,
  SECONDARY_COLOR: Styles.color.grey.eight,
};

export const POINTS_ICON_FILL_COLOR = undefined;
